import { render, staticRenderFns } from "./inviteData.vue?vue&type=template&id=b6a8c254&scoped=true"
import script from "./inviteData.vue?vue&type=script&lang=js"
export * from "./inviteData.vue?vue&type=script&lang=js"
import style0 from "./inviteData.vue?vue&type=style&index=0&id=b6a8c254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a8c254",
  null
  
)

export default component.exports